import React from 'react';

const About = () => {
  return (
    <div className="section about-container bg-gray" id="about">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 d-none d-lg-block text-center">
            <img
              src="assets/img/illustration/2.png"
              alt="About Illustration"
              className="about-img"
            />
          </div>

          <div className="col-lg-6 col-md-12 text-wrapper">
            <h4 className="section-heading-left">About Us</h4>
            <h3 className="section-subtitle-left">Where insight meets impact</h3>
            <p>We believe that better decisions come from better understanding, and that starts with your data.</p>
            <p>Based in Cheshire, UK, Deed Analytics brings deep expertise in SQL, Python, and Power BI to bridge the technical and the strategic, helping businesses move forward with confidence.</p>
            
            <div className="about-list-container">
              <ul className="about-list">
                <li>
                  <div className="title-container">
                    <h5 className="heading-left"><strong>Clarity through custom dashboards</strong></h5>
                  </div>
                  <p>We turn your data into clear, visual stories and tailored dashboards that highlight what matters most to your business.</p>
                </li>
                <li>
                  <div className="title-container">
                    <h5 className="heading-left"><strong>Smart solutions for complex problems</strong></h5>
                  </div>
                  <p>Whether it's forecasting, process automation, or data quality, we solve challenges with measurable impact.</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
